export default __webpack_public_path__ + "static/media/Logo-Protean.68d638f7.svg";